import { colorsPalettes } from "@similarweb/styles";

import type { TagColumnValueResponse } from "app/pages/sales-intelligence/modules/lists/types/columns";

export const getTagColor = (tag: TagColumnValueResponse): string => {
    return tag.ColorHex ?? colorsPalettes.carbon[250];
};
